import React, { useContext, useEffect } from 'react';
import SimpleButton from '../../components/common/buttons/SimpleButton/SimpleButton';
import { AppContext } from '../../appContext';

export default function LogutSection({ }) {
    const { logout } = useContext(AppContext);
    return (
        <section className="mt-16 lg:mt-8 lg:max-w-md w-full px-2 custom_x_margin custom_pt_md">
        <div className="flex justify-center items-center flex ml-auto mr-auto flex-col gap-1">
            <img
                src={require('../../images/logout.png')}
                className="object-contain mb-2"
            />
            <div className="text-base font-medium lg:text-lg lg:font-medium text-center !mb-2">
                  Are you sure you want to log out?
            </div>
            <p className="text-navLink text-sm text-center">
            Don’t worry, everything you did will still be there when you log back in!
            </p>
        </div>
        
          <div className='mt-8 max-w-md ml-auto mr-auto'>
            <SimpleButton
              customClass={'bg-accent text-white rounded-lg w-full'}
              buttonType={'primary'}
              title={'Yes, log me out!'}
              onClickEvent={() => {
                logout();
              }}
            />
          </div>
        </section>
    )
}